<template>
	<section class="content">
		<form class="row" role="form" @submit.prevent="createVoucher">
			<div class="col-12 position-static" style="top: 5rem;z-index: 1000">
				<div class="row justify-content-end">
					<div class="col-auto" v-if="!$route.params.id">
						<button type="submit" @click="forms.save = 'draft'" class="btn btn-outline-primary"><i class="fi fi-rr-file-download"></i> Simpan ke draft</button>
					</div>
					<div class="col-auto" v-if="active == '1'">
						<button type="submit" @click="forms.save = 'inactive'" class="btn btn-danger"><i class="fi fi-rr-cross"></i> Nonaktifkan Voucher</button>
					</div>
					<div class="col-auto" v-else>
						<button type="submit" @click="forms.save = 'publish'" class="btn btn-primary"><i class="fi fi-rr-plus"></i> {{ $route.params.id ? 'Aktifkan' : 'Publish' }} voucher</button>
					</div>
				</div>
			</div>
			<div class="col-lg-6 mt-3">
				<div class="card border rounded mb-3">
					<div class="card-body pb-1">
						<div class="border-bottom mb-3">
							<label class="h5">Detail Voucher</label>
						</div>
						<div class="form-group">
							<label>Kode Voucher</label>
							<div class="row" style="row-gap: 15px;">
								<div class="col">
									<div class="form-control h-100" :class="{ 'border-primary' : forms.generate === true }" :style="{ backgroundColor: forms.generate === true ? '#ffe1c9' : '#fff' }" style="border-width: 2px;">
										<div class="icheck-material-orange w-100">
											<input type="radio" @click="resetCode()" id="random" name="voucher-generate" v-model="forms.generate" :value="true" :disabled="$route.params.id && active > 0" required />
											<label for="random" class="form-check-label w-100">Random generate</label>
										</div>
									</div>
								</div>
								<div class="col">
									<div class="form-control h-100" :class="{ 'border-primary' : forms.generate === false }" :style="{ backgroundColor: forms.generate === false ? '#ffe1c9' : '#fff' }" style="border-width: 2px;">
										<div class="icheck-material-orange w-100">
											<input type="radio" @click="resetCode()" id="manual" name="voucher-generate" v-model="forms.generate" :value="false" :disabled="$route.params.id && active > 0" required />
											<label for="manual" class="form-check-label w-100">Manual generate</label>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="form-group" v-if="forms.generate !== null">
							<div class="form-control bg-light border-light p-3 h-100">
								<div class="row">
									<div class="col-auto" v-if="forms.generate === true">
										<button type="button" @click="generateCode" :disabled="repeat && forms.code.length < 8 || ($route.params.id && active > 0)" class="btn btn-primary">Generate</button>
									</div>
									<div class="col">
										<div class="input-group">
											<input type="text" name="voucher-code" v-model="forms.code" @input="filterAlphanumeric" :placeholder="forms.generate === true ? 'Klik generate' : 'Cth: BOSCODPROMOJUNI'" minlength="8" maxlength="30" :disabled="disableCode" class="form-control border-right-0" :class="{ 'is-invalid': errors.code, 'bg-white' : !$route.params.id || active < 1 }" required />
											<div class="input-group-append cursor-pointer" ref="copyCode" @click="copyCode(forms.code)" data-toggle="tooltip" data-placement="top" title="Salin ke papan klip">
												<div class="input-group-text rounded-right d-flex align-items-center border-left-0" :class="{ 'border-danger': errors.code, 'bg-white' : !$route.params.id || active < 1 }">
													<i class="fi fi-rr-copy-alt text-primary"></i>
												</div>
											</div>
										</div>
										<small :class="errors.code ? 'text-danger' : 'text-success'" v-if="errors.code_message">{{ errors.code_message }}</small>
									</div>
									<div class="col-auto" v-if="forms.generate === false">
										<button type="button" @click="checkCode" class="btn btn-primary" :disabled="loading || (!errors.code && errors.code_message) || ($route.params.id && active > 0)">Simpan</button>
									</div>
								</div>
							</div>
						</div>

						<div class="form-group h-100">
							<label>Deskripsi Voucher</label>
							<textarea name="voucher-description" v-model="forms.description" @change="errors.description = false" placeholder="Masukkan deskripsi voucher" minlength="15" maxlength="200" :disabled="$route.params.id && active > 0" class="form-control h-100" :class="{ 'is-invalid': errors.description }" style="resize: none;" required
								onkeydown="return (event.ctrlKey || event.altKey || (47<event.keyCode && event.keyCode<58 && event.shiftKey==false) || (event.keyCode==57 && event.shiftKey==true) || (95<event.keyCode && event.keyCode<106) || (event.keyCode==8) || (event.keyCode==9) || (event.keyCode==48 && event.shiftKey==true) || (event.keyCode==190 && event.shiftKey==false) || (event.keyCode==188 && event.shiftKey==false) || (34<event.keyCode && event.keyCode<40) || (event.keyCode==32) || (event.keyCode==46) || (event.keyCode==13) || (64<event.keyCode && event.keyCode<91))">
							</textarea>
							<small class="text-danger" v-if="errors.description">Deskripsi voucher tidak boleh kosong</small>
						</div>

						<div class="form-group">
							<div class="row" style="row-gap: 15px;">
								<div class="col-md-5">
									<label>Tipe Nominal</label>
									<select name="voucher-type" v-model="forms.type" @change="resetType()" :disabled="$route.params.id && active > 0" class="form-control" required>
										<option value="percentage">Percentage (%)</option>
										<option value="fixed">Fixed Amount (Rp)</option>
									</select>
								</div>
								<div class="col-6 col-md-3" v-if="forms.type == 'percentage'">
									<label>Persentase</label>
									<div class="input-group">
										<input type="number" min="1" name="voucher-percentage" v-model="forms.percentage" placeholder="Persentase" :disabled="$route.params.id && active > 0" class="form-control border-right-0 pr-0" :required="forms.type == 'percentage'" />
										<div class="input-group-append">
											<div class="input-group-text rounded-right d-flex align-items-center border-left-0 pl-0" :class="{ 'bg-white' : !$route.params.id || active < 1 }">
												<i class="fi fi-rr-percentage text-primary"></i>
											</div>
										</div>
									</div>
								</div>
								<div class="col-6 col-md-4" v-if="forms.type == 'percentage'">
									<label>Nominal&nbsp;Maksimal</label>
									<div class="input-group">
										<currency-input name="voucher-nominal" v-model="forms.nominal" currency="IDR" currencyDisplay="narrowSymbol" :precision="0" placeholder="Nominal" :disabled="$route.params.id && active > 0" class="form-control border-right-0 pr-0" :required="forms.type == 'percentage'" />
										<div class="input-group-append">
											<div class="input-group-text rounded-right d-flex align-items-center border-left-0 pl-0" :class="{ 'bg-white' : !$route.params.id || active < 1 }">
												<i class="fi fi-rr-rupiah-sign text-primary"></i>
											</div>
										</div>
									</div>
								</div>
								<div class="col-md-7" v-if="forms.type == 'fixed'">
									<label>Besaran Nominal</label>
									<div class="input-group">
										<currency-input name="voucher-fixed" v-model="forms.fixed" currency="IDR" currencyDisplay="narrowSymbol" :precision="0" placeholder="Nominal" :disabled="$route.params.id && active > 0" class="form-control border-right-0" :required="forms.type == 'fixed'" />
										<div class="input-group-append">
											<div class="input-group-text rounded-right d-flex align-items-center border-left-0" :class="{ 'bg-white' : !$route.params.id || active < 1 }">
												<i class="fi fi-rr-rupiah-sign text-primary"></i>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="form-group">
							<div class="form-control bg-light border-light p-3 h-100">
								<div class="input-group">
									<input type="text" name="voucher-resume" v-model="forms.resume" :placeholder="'Masukkan ' + (forms.type == 'percentage' ? forms.percentage > 0 ? 'nominal maksimal' : 'nilai persentase' : 'nominal')" class="form-control border-right-0" :class="{ 'is-invalid': errors.resume, 'bg-white' : !$route.params.id || active < 1 }" required readonly />
									<div class="input-group-append cursor-pointer" ref="copyResume" @click="copyResume(forms.resume)" data-toggle="tooltip" data-placement="top" title="Salin ke papan klip">
										<div class="input-group-text rounded-right d-flex align-items-center border-left-0" :class="{ 'border-danger': errors.resume, 'bg-white' : !$route.params.id || active < 1 }">
											<i class="fi fi-rr-copy-alt text-primary"></i>
										</div>
									</div>
								</div>
								<small class="text-danger" v-if="errors.resume">Lengkapi dulu nilai dari presentase dan nominal maksimal</small>
							</div>
						</div>

						<div class="form-group h-100">
							<label>Periode Voucher</label>
							<div class="input-group">
								<input type="text" name="voucher-period" ref="period" :disabled="$route.params.id && active > 0" class="form-control border-right-0" required />
								<div class="input-group-append">
									<div class="input-group-text rounded-right d-flex align-items-center border-left-0" :class="{ 'bg-white' : !$route.params.id || active < 1 }">
										<i class="fi fi-rr-calendar d-flex"></i>
									</div>
								</div>
							</div>
						</div>

						<div class="form-group">
							<label>Kuota Voucher</label>
							<div class="row">
								<div class="col-7">
									<select name="voucher-quota" v-model="forms.quota" :disabled="$route.params.id && active > 0" class="form-control" required>
										<option value="" selected disabled hidden>Pilih opsi kuota</option>
										<option value="limited">Kuota ditentukan</option>
										<option value="unlimited">Kuota unlimited</option>
									</select>
								</div>
								<div class="col-5">
									<input type="number" name="voucher-limit" v-model="forms.limit" :placeholder="forms.quota == '' ? 'Pilih opsi nominal' : forms.quota == 'limited' ? 'Masukkan kuota' : forms.quota == 'unlimited' ? 'Kuota unlimited' : ''" :disabled="forms.quota != 'limited' || $route.params.id && active > 0" class="form-control" :class="{ 'is-invalid': errors.limit && forms.quota == 'limited' }" :required="forms.quota == 'limited'" />
									<small class="text-danger" v-if="errors.limit && forms.quota == 'limited'">Kuota tidak boleh kosong</small>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 mt-3">
				<div class="card border rounded mb-3">
					<div class="card-body pb-1">
						<div class="border-bottom mb-3">
							<label class="h5">Rule Voucher</label>
						</div>
						<div class="form-group">
							<div class="form-control bos-alert-primary d-flex align-items-center h-100">
								<div class="row">
									<div class="col-auto d-flex align-items-center">
										<i class="fi fi-rr-info d-flex align-items-center h5 mb-0"></i>
									</div>
									<div class="col d-flex align-items-center lh-1">
										<div class="text-md">
											Rule voucher digunakan untuk mengatur ketentuan-ketentuan tertentu saat pembuatan voucher
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="form-group">
							<label>Batas penggunaan voucher</label>
							<select name="voucher-usage" v-model="forms.usage" :disabled="$route.params.id && active > 0" class="form-control" required>
								<option value="" selected disabled hidden>-- Pilih opsi --</option>
								<option value="daily_usage">Daily fair usage</option>
								<option value="fair_usage">Fair usage</option>
								<option value="user_limit" disabled hidden>Per user limit</option>
							</select>
						</div>
						<div class="form-group">
							<div class="form-control bg-light border-light p-3 h-100" v-if="forms.usage != ''">
								<label>Maksimal Voucher</label>
								<input type="number" name="voucher-maximum" v-model="forms.maximum" :min="forms.usage != '' ? 1 : 0" :disabled="forms.usage == 'user_limit' || $route.params.id && active > 0" class="form-control" :required="forms.usage != ''" />
							</div>
						</div>

						<div class="form-group">
							<label>Pembatasan kurir</label>
							<select name="voucher-courier" v-model="forms.courier" @change="resetCourier()" :disabled="$route.params.id && active > 0" class="form-control" required>
								<option value="all">Semua kurir</option>
								<option value="custom">Pilih kurir tertentu</option>
							</select>
						</div>
						<div class="form-group">
							<div class="form-control bg-light pt-2 h-100" v-if="forms.courier == 'custom'">
								<div class="row">
									<div class="col-6 col-sm-4 h-100" v-for="(courier) in listCourier">
										<div class="icheck-material-orange w-100">
											<input type="checkbox" :id="courier.prefix" name="voucher-service[]" v-model="forms.prefix" @change="resetService()" :value="courier.id" :disabled="$route.params.id && active > 0" :required="forms.courier == 'custom' && forms.prefix.length < 1" />
											<label :for="courier.prefix" class="form-check-label text-xs w-100">{{ courier.nama }}</label>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="form-group" v-if="false">
							<label>Minimal nilai transaksi</label>
							<select name="voucher-minimum" v-model="forms.minimum" @change="resetMinimum()" :disabled="$route.params.id && active > 0" class="form-control" required>
								<option value="none">Tidak ada minimal transaksi</option>
								<option value="value">Dengan nilai COD atau nilai ongkir</option>
							</select>
						</div>
						<div class="form-group">
							<div class="form-control bg-light border-light p-3 h-100" v-if="forms.minimum == 'value'">
								<label>Nilai COD atau Nilai Ongkir</label>
								<currency-input name="voucher-value" v-model="forms.value" currency="IDR" currencyDisplay="narrowSymbol" :precision="0" placeholder="Nilai" :disabled="$route.params.id && active > 0" class="form-control" :required="forms.minimum == 'value'" />
							</div>
						</div>

						<div class="form-group" v-if="false">
							<label>Area yang berlaku</label>
							<select name="voucher-coverage" v-model="forms.coverage" @change="resetCoverage()" :disabled="$route.params.id && active > 0" class="form-control" required>
								<option value="all">Semua area</option>
								<option value="custom">Pilih area tertentu</option>
							</select>
						</div>
						<div class="form-group" v-if="forms.coverage == 'custom'">
							<div class="form-control bg-light border-light p-3 h-100">
								<div class="form-group">
									<label>Asal Pengiriman</label>
									<v-select :options="listProvince" :reduce="opt => opt.id" name="voucher-origin" v-model="forms.origin" open-direction="above" placeholder="-- Pilih provinsi --" multiple :disabled="$route.params.id && active > 0">
										<template slot="no-options">
											Nama provinsi tidak ditemukan
										</template>
										<template #search="{attributes, events}">
											<input class="vs__search" :required="forms.coverage == 'custom' && forms.origin.length < 1" v-bind="attributes" v-on="events" />
										</template>
									</v-select>
								</div>
								<div class="form-group mb-0">
									<label>Tujuan Pengiriman</label>
									<v-select :options="listProvince" :reduce="opt => opt.id" name="voucher-destination" v-model="forms.destination" open-direction="above" placeholder="-- Pilih provinsi --" multiple :disabled="$route.params.id && active > 0">
										<template slot="no-options">
											<em style="opacity: 0.5">Nama provinsi tidak ditemukan</em>
										</template>
										<template #search="{attributes, events}">
											<input class="vs__search" :required="forms.coverage == 'custom' && forms.destination.length < 1" v-bind="attributes" v-on="events" />
										</template>
									</v-select>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="card border rounded mb-3">
					<div class="card-body pb-1">
						<div class="border-bottom mb-3">
							<label class="h5">Publikasi Voucher</label>
						</div>

						<div class="form-group">
							<label>Publikasi voucher</label>
							<select name="voucher-publicity" v-model="forms.publicity" @change="resetPublicity()" :disabled="$route.params.id && active > 0" class="form-control" required>
								<option value="" selected disabled hidden>-- Pilih opsi --</option>
								<option value="public">Public</option>
								<option value="private">Private</option>
							</select>
						</div>

						<div class="form-group" :hidden="!(forms.publicity == 'private')">
							<div class="form-control bg-light border-light p-3 h-100">
								<div class="form-group">
									<label>Personalisasi voucher</label>
									<div class="row">
										<div class="col-sm">
											<select name="voucher-personality1" v-model="forms.personality1" @change="resetPersonality1()" :disabled="$route.params.id && active > 0" class="form-control" :required="forms.publicity == 'private'">
												<option value="" selected disabled hidden>-- Pilih opsi --</option>
												<option value="shipper">ID Shipper</option>
												<option value="service">Service Kurir</option>
												<option value="member">Membership</option>
												<option value="join" hidden>Tanggal Bergabung</option>
												<option value="shipping" hidden>Jumlah Kiriman</option>
											</select>
										</div>

										<div class="col-sm-7" :hidden="!(forms.personality1 == 'shipper')">
											<v-select :options="listShipper1" :reduce="opt => opt.id" ref="shipper" name="voucher-shipper1" v-model="selectShipper1" @search="searchShipper1" open-direction="above" placeholder="Pilih shipper" :disabled="$route.params.id && active > 0" :required="forms.personality1 == 'shipper'">
												<template v-slot:no-options="{ search, searching }">
													<template v-if="searching && search.length > 3">
														<em style="opacity: 0.5">Nama/Kode shipper {{ search }} tidak ditemukan.</em>
													</template>
													<em v-else style="opacity: 0.5">Ketik nama/kode shipper</em>
												</template>
												<template #search="{attributes, events}">
													<input class="vs__search" :required="forms.personality1 == 'shipper' && viewShipper1.length < 1" v-bind="attributes" v-on="events" />
												</template>
											</v-select>
										</div>

										<div class="col-sm-7" :hidden="!(forms.personality1 == 'service')">
											<v-select :options="listService1" :reduce="opt => opt.id" name="voucher-service1" v-model="forms.service1" open-direction="above" placeholder="Pilih service" multiple :disabled="$route.params.id && active > 0" :required="forms.personality1 == 'service'">
												<template v-slot:no-options="{ search, searching }">
													<em style="opacity: 0.5">Service {{ search }} tidak tersedia</em>
												</template>
												<template #search="{attributes, events}">
													<input class="vs__search" :required="forms.personality1 == 'service' && forms.service1.length < 1" v-bind="attributes" v-on="events" />
												</template>
											</v-select>
										</div>

										<div class="col-sm-7" :hidden="!(forms.personality1 == 'member')">
											<v-select :options="listMember1" :reduce="opt => opt.id" name="voucher-member1" v-model="forms.member1" open-direction="above" placeholder="Pilih membership" multiple :disabled="$route.params.id && active > 0" :required="forms.personality1 == 'member'">
												<template v-slot:no-options="{ search, searching }">
													<em style="opacity: 0.5">Membership {{ search }} tidak tersedia</em>
												</template>
												<template #search="{attributes, events}">
													<input class="vs__search" :required="forms.personality1 == 'member' && forms.member1.length < 1" v-bind="attributes" v-on="events" />
												</template>
											</v-select>
										</div>

										<div class="col-sm-7" :hidden="!(forms.personality1 == 'join')">
											<div class="input-group">
												<input type="text" name="voucher-join-date-1" ref="join_date1" :disabled="$route.params.id && active > 0" class="form-control border-right-0" :required="forms.personality1 == 'join'" />
												<div class="input-group-append">
													<div class="input-group-text rounded-right d-flex align-items-center border-left-0" :class="{ 'bg-white' : !$route.params.id || active < 1 }">
														<i class="fi fi-rr-calendar d-flex"></i>
													</div>
												</div>
											</div>
										</div>

										<div class="col-sm-7" :hidden="!(forms.personality1 == 'shipping')">
											<input type="number" name="voucher-shipping1" v-model="forms.shipping1" placeholder="Masukkan jumlah kiriman" :disabled="$route.params.id && active > 0" class="form-control" :required="forms.personality1 == 'shipping'" />
										</div>
									</div>
								</div>

								<div class="form-group" v-if="forms.personality1 == 'shipper' && viewShipper1.length">
									<div class="form-control p-0 pb-1 h-100">
										<div class="vs__selected-options">
											<div class="vs__selected" v-for="(shipper) in viewShipper1">
												{{ shipper.label }} <button type="button" class="vs__deselect" @click="removeShipper1(shipper.id, shipper.shipper_code)" :disabled="$route.params.id && active > 0">&#128473;</button>
											</div>
										</div>
									</div>
								</div>

								<div class="form-group" :hidden="!forms.shipper1.length && !forms.service1.length && !forms.member1.length && forms.join_start1 == null && forms.join_end1 == null && forms.shipping1 == null">
									<div class="row">
										<div class="col-sm">
											<select name="voucher-personality2" v-model="forms.personality2" @change="resetPersonality2()" :disabled="$route.params.id && active > 0" class="form-control">
												<option value="" selected disabled hidden>-- Tambah opsi --</option>
												<option value="shipper" :disabled="forms.personality1 == 'shipper'">ID Shipper</option>
												<option value="service" :disabled="forms.personality1 == 'service'">Service Kurir</option>
												<option value="member" :disabled="forms.personality1 == 'member'">Membership</option>
												<option value="join" :disabled="forms.personality1 == 'join'" hidden>Tanggal Bergabung</option>
												<option value="shipping" :disabled="forms.personality1 == 'shipping'" hidden>Jumlah Kiriman</option>
											</select>
										</div>

										<div class="col-sm-7" :hidden="!(forms.personality2 == 'shipper')">
											<v-select :options="listShipper2" :reduce="opt => opt.id" ref="shipper" name="voucher-shipper2" v-model="selectShipper2" @search="searchShipper2" open-direction="above" placeholder="Pilih shipper" :disabled="$route.params.id && active > 0" :required="forms.personality2 == 'shipper'">
												<template v-slot:no-options="{ search, searching }">
													<template v-if="searching && search.length > 3">
														<em style="opacity: 0.5">Nama/Kode shipper {{ search }} tidak ditemukan.</em>
													</template>
													<em v-else style="opacity: 0.5">Ketik nama/kode shipper</em>
												</template>
												<template #search="{attributes, events}">
													<input class="vs__search" :required="forms.personality2 == 'shipper' && viewShipper2.length < 1" v-bind="attributes" v-on="events" />
												</template>
											</v-select>
										</div>

										<div class="col-sm-7" :hidden="!(forms.personality2 == 'service')">
											<v-select :options="listService2" :reduce="opt => opt.id" name="voucher-service2" v-model="forms.service2" open-direction="above" placeholder="Pilih service" multiple :disabled="$route.params.id && active > 0" :required="forms.personality2 == 'service'">
												<template v-slot:no-options="{ search, searching }">
													<em style="opacity: 0.5">Service {{ search }} tidak tersedia</em>
												</template>
												<template #search="{attributes, events}">
													<input class="vs__search" :required="forms.personality2 == 'service' && forms.service2.length < 1" v-bind="attributes" v-on="events" />
												</template>
											</v-select>
										</div>

										<div class="col-sm-7" :hidden="!(forms.personality2 == 'member')">
											<v-select :options="listMember2" :reduce="opt => opt.id" name="voucher-member2" v-model="forms.member2" open-direction="above" placeholder="Pilih membership" multiple :disabled="$route.params.id && active > 0" :required="forms.personality2 == 'member'">
												<template v-slot:no-options="{ search, searching }">
													<em style="opacity: 0.5">Membership {{ search }} tidak tersedia</em>
												</template>
												<template #search="{attributes, events}">
													<input class="vs__search" :required="forms.personality2 == 'member' && forms.member2.length < 1" v-bind="attributes" v-on="events" />
												</template>
											</v-select>
										</div>

										<div class="col-sm-7" :hidden="!(forms.personality2 == 'join')">
											<div class="input-group">
												<input type="text" name="voucher-join-date-2" ref="join_date2" :disabled="$route.params.id && active > 0" class="form-control border-right-0" :required="forms.personality2 == 'join'" />
												<div class="input-group-append">
													<div class="input-group-text rounded-right d-flex align-items-center border-left-0" :class="{ 'bg-white' : !$route.params.id || active < 1 }">
														<i class="fi fi-rr-calendar d-flex"></i>
													</div>
												</div>
											</div>
										</div>

										<div class="col-sm-7" :hidden="!(forms.personality2 == 'shipping')">
											<input type="number" name="voucher-shipping2" v-model="forms.shipping2" placeholder="Masukkan jumlah kiriman" :disabled="$route.params.id && active > 0" class="form-control" :required="forms.personality2 == 'shipping'" />
										</div>
									</div>
								</div>

								<div class="form-group" v-if="forms.personality2 == 'shipper' && viewShipper2.length">
									<div class="form-control p-0 pb-1 h-100">
										<div class="vs__selected-options">
											<div class="vs__selected" v-for="(shipper) in viewShipper2">
												{{ shipper.label }} <button type="button" class="vs__deselect" @click="removeShipper2(shipper.id, shipper.shipper_code)" :disabled="$route.params.id && active > 0">&#128473;</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</form>
	</section>
</template>
<script>
import { authFetch, formatCurrency } from "@/libs/hxcore";
import Swal from "sweetalert2";
import moment from "moment";
import { CurrencyInput } from "vue-currency-input";
import Daterangepicker from "daterangepicker";
import "daterangepicker/daterangepicker.css";
import "icheck-material";
import vSelect from 'vue-select';
import "vue-select/dist/vue-select.css";
import $ from "jquery";

export default {
	name: "FormVoucher",
	data() {
		return {
			loading: false,
			active: null,
			repeat: false,
			listCourier: [],
			listProvince: [],
			listShipper1: [],
			selectShipper1: null,
			viewShipper1: [],
			listService1: [],
			listMember1: [],
			listShipper2: [],
			selectShipper2: null,
			viewShipper2: [],
			listService2: [],
			listMember2: [],
			forms: {
				id: null,
				save: null,
				generate: null,
				code: '',
				description: '',
				type: 'percentage',
				percentage: null,
				nominal: null,
				fixed: null,
				resume: null,
				period_start: moment().startOf("month").format("YYYY-MM-DD"),
				period_end: moment().endOf("month").format("YYYY-MM-DD"),
				quota: '',
				limit: null,
				usage: '',
				maximum: null,
				courier: 'all',
				prefix: [],
				minimum: 'none',
				value: null,
				coverage: 'all',
				origin: [],
				destination: [],
				publicity: '',
				personality1: '',
				shipper1: [],
				service1: [],
				member1: [],
				join_start1: null,
				join_end1: null,
				shipping1: null,
				personality2: '',
				shipper2: [],
				service2: [],
				member2: [],
				join_start2: null,
				join_end2: null,
				shipping2: null
			},
			errors: {
				code: false,
				code_message: '',
				description: false,
				resume: false,
				limit: false
			}
		};
	},
	created: function () {
	},
	methods: {
		getImage(file) {
			return require(`../assets/img/${file}.svg`); // the module request
		},
		resetCode: function() {
			this.forms.code = '';
			this.errors.code = false;
			this.errors.code_message = false;
		},
		generateCode: function() {
			if (this.forms.code.length < 8) {
				this.forms.code += Math.random() < 0.8 ?
				String.fromCharCode(65 + Math.floor(Math.random() * 26))
				:
				String.fromCharCode(48 + Math.floor(Math.random() * 10));
				this.repeat = setTimeout(this.generateCode, 100);
			} else if (this.repeat) {
				this.repeat =  false;
			} else {
				this.forms.code = '';
				this.repeat = setTimeout(this.generateCode);
			}
		},
		filterAlphanumeric: function(e) {
			const raw = e.target.value;
			const filtered = raw.replace(/[^a-zA-Z0-9]/g, "");
			this.forms.code = filtered;
		},
		checkCode: function() {
			if (!this.forms.code) {
				this.customSwal.fire({
					icon: 'error',
					title: 'Kode voucher tidak boleh kosong',
				}).then(() => {
					this.errors.code = true;
					this.errors.code_message = 'Kode voucher tidak boleh kosong';
				});
				return;
			}

			this.loading = true;
			authFetch("/shipper/voucher/check_code/" + this.forms.code).then(res => {
				res.json().then((json) => {
					this.loading = false;

					if (json.success) {
						this.errors.code = json.duplicate;
						this.errors.code_message = json.message;
					}
				});
			});
		},
		copyCode: function(text) {
			const self = this;
			navigator.clipboard.writeText(text).then(function() {
				$(self.$refs.copyCode).attr('title','Berhasil menyalin Kode Voucher').tooltip('_fixTitle').tooltip('show').attr('title','Salin').tooltip('_fixTitle')
			}, function(err) {
				console.error(err);
			});
		},
		copyResume: function(text) {
			const self = this;
			navigator.clipboard.writeText(text).then(function() {
				$(self.$refs.copyResume).attr('title','Berhasil menyalin Judul Voucher').tooltip('_fixTitle').tooltip('show').attr('title','Salin').tooltip('_fixTitle')
			}, function(err) {
				console.error(err);
			});
		},
		resetType: function() {
			this.forms.resume = null;
			this.forms.percentage = null;
			this.forms.nominal = null;
			this.forms.fixed = null;
			this.errors.resume = false;
		},
		resetCourier: function() {
			this.forms.prefix = [];
			this.listService1 = [];
			this.listService2 = [];

			// reset publicity
			this.forms.publicity = '';
			this.resetPublicity();
		},
		resetMinimum: function() {
			this.forms.value = null;

			// reset publicity
			// this.forms.publicity = '';
			// this.resetPublicity();
		},
		resetCoverage: function() {
			this.forms.origin = [];
			this.forms.destination = [];

			// reset publicity
			// this.forms.publicity = '';
			// this.resetPublicity();
		},
		resetPublicity: function() {
			this.forms.personality1 = '';
			this.forms.personality2 = '';

			// // reset usage
			// this.forms.usage = '';
			// this.forms.maximum = null;

			// // reset courier
			// this.forms.courier = '';
			// this.forms.prefix = [];
			// this.listService1 = [];
			// this.listService2 = [];

			// // reset minimum
			// this.forms.minimum = '';
			// this.forms.value = null;

			// // reset coverage
			// this.forms.coverage = '';
			// this.forms.origin = [];
			// this.forms.destination = [];

			this.resetPersonality1();
		},
		resetPersonality1: function() {
			this.listShipper1 = [];
			this.selectShipper1 = null;
			this.viewShipper1 = [];
			this.listService1 = [];
			this.forms.shipper1 = [];
			this.forms.service1 = [];
			this.forms.member1 = [];

			if (this.forms.personality1 == 'join') {
				this.forms.join_start1 = moment().startOf("month").format("YYYY-MM-DD");
				this.forms.join_end1 = moment().endOf("month").format("YYYY-MM-DD");
				const self = this;

				new Daterangepicker(
					this.$refs.join_date1,
					{
						startDate: moment().startOf("month"),
						endDate: moment().endOf("month"),
						locale: {
							format: 'DD/MM/YYYY'
						},
					},
					function (d1, d2) {
						self.forms.join_start1 = d1.format("YYYY-MM-DD");
						self.forms.join_end1 = d2.format("YYYY-MM-DD");
					}
				);
			} else {
				this.forms.join_start1 = null;
				this.forms.join_end1 = null;
			}

			this.forms.shipping1 = null;
			this.resetPersonality2();
		},
		resetPersonality2: function() {
			this.listShipper2 = [];
			this.selectShipper2 = null;
			this.viewShipper2 = [];
			this.listService2 = [];
			this.forms.shipper2 = [];
			this.forms.service2 = [];
			this.forms.member2 = [];

			if (this.forms.personality2 == 'join') {
				this.forms.join_start2 = moment().startOf("month").format("YYYY-MM-DD");
				this.forms.join_end2 = moment().endOf("month").format("YYYY-MM-DD");
				const self = this;

				new Daterangepicker(
					this.$refs.join_date2,
					{
						startDate: moment().startOf("month"),
						endDate: moment().endOf("month"),
						locale: {
							format: 'DD/MM/YYYY'
						},
					},
					function (d1, d2) {
						self.forms.join_start2 = d1.format("YYYY-MM-DD");
						self.forms.join_end2 = d2.format("YYYY-MM-DD");
					}
				);
			} else {
				this.forms.join_start2 = null;
				this.forms.join_end2 = null;
			}

			this.forms.shipping2 = null;
		},
		resetService: function() {
			this.listService1 = [];
			this.forms.service1 = [];

			this.listService2 = [];
			this.forms.service2 = [];
		},
		searchShipper1: function(search, loading) {
			if (search.length > 3 && this.loading === false) {
				loading(true);
				this.loading = true;
				authFetch(`/order/shipper?search=${escape(search)}`)
				.then((res) => {
					if (res.status !== 200) {
						loading(false);
						this.loading = false;
					}
					return res.json();
				})
				.then((js) => {
					this.listShipper1 = js.data;
				});
				loading(false);
				this.loading = false;
			}
		},
		searchShipper2: function(search, loading) {
			if (search.length > 3 && this.loading === false) {
				loading(true);
				this.loading = true;
				authFetch(`/order/shipper?search=${escape(search)}`)
				.then((res) => {
					if (res.status !== 200) {
						loading(false);
						this.loading = false;
					}
					return res.json();
				})
				.then((js) => {
					this.listShipper2 = js.data;
				});
				loading(false);
				this.loading = false;
			}
		},
		removeShipper1(id, code) {
			this.viewShipper1 = this.viewShipper1.filter((e) => e.id !== id);
			this.forms.shipper1 = this.forms.shipper1.filter((e) => e !== code);
		},
		removeShipper2(id, code) {
			this.viewShipper2 = this.viewShipper2.filter((e) => e.id !== id);
			this.forms.shipper2 = this.forms.shipper2.filter((e) => e !== code);
		},
		createVoucher() {
			const type = this.forms.save;
			this.loading = true;

			this.customSwal.fire({
				html: '<img src="' + this.getImage(type == 'inactive' ? 'reject' : 'voucher') + '" class="swal2-ico d-block mx-auto mb-3" /><div class="h5">Yakin ingin ' + (type == 'draft' ? 'simpan ke draft' : type == 'inactive' ? 'nonaktifkan voucher' : 'aktifkan voucher') + '?</div>',
				showDenyButton: true,
				confirmButtonText: type == 'draft' ? 'Simpan ke draft' : type == 'inactive' ? 'Nonaktifkan' : 'Aktifkan',
				denyButtonText: 'Batal'
			}).then((result) => {
				if (result.isConfirmed) {
					authFetch('/shipper/voucher', {
						method: this.$route.params.id ? 'PUT' : 'POST',
						body: Object.keys(this.forms).map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(this.forms[key] == null ? '' : this.forms[key])).join("&")
					})
					.then(res => {
						if (res.status === 201) {} else if (res.status === 400) {}
						return res.json();
					})
					.then(js => {
						this.customSwal.fire({
							html: '<img src="' + this.getImage(js.success ? 'ok' : 'overload') + '" class="swal2-img d-block mx-auto mb-3" /><div class="h5">' + (js.success ? js.message : js.type == 'error_input' ? 'Data tidak lengkap' : 'Terjadi kesalahan') + '</div><div class="w-75 m-auto" style="max-height: 100px;overflow-y: scroll;">' + (js.details ? '<ul class="text-left"><li>' + Object.keys(js.details).map(key => js.details[key]).join('</li><li>') + '</li></ul>' : '') + '</div>',
							showConfirmButton: false,
							showCancelButton: true,
							cancelButtonText: js.success ? 'Oke' : 'Coba lagi'
						}).then((result) => {
							if (js.success) {
								this.loading = false;
								this.active = null;
								this.repeat = false;
								this.listShipper1 = [];
								this.selectShipper1 = null;
								this.viewShipper1 = [];
								this.listService1 = [];
								this.listMember1 = [];
								this.listShipper2 = [];
								this.selectShipper2 = null;
								this.viewShipper2 = [];
								this.listService2 = [];
								this.listMember2 = [];
								this.forms = {
									id: null,
									save: null,
									generate: null,
									code: '',
									description: '',
									type: 'percentage',
									percentage: null,
									nominal: null,
									fixed: null,
									resume: null,
									period_start: moment().startOf("month").format("YYYY-MM-DD"),
									period_end: moment().endOf("month").format("YYYY-MM-DD"),
									quota: '',
									limit: null,
									usage: '',
									maximum: null,
									courier: 'all',
									prefix: [],
									minimum: 'none',
									value: null,
									coverage: 'all',
									origin: [],
									destination: [],
									publicity: '',
									personality1: '',
									shipper1: [],
									service1: [],
									member1: [],
									join_start1: null,
									join_end1: null,
									shipping1: null,
									personality2: '',
									shipper2: [],
									service2: [],
									member2: [],
									join_start2: null,
									join_end2: null,
									shipping2: null
								};
								this.errors = {
									code: false,
									description: false,
									resume: false,
									limit: false
								};

								this.$router.push({ path: "/blast-voucher" });
							}
						});
					});
				}
				this.loading = false;
			});
		
		}
	},
	components: {
		CurrencyInput,
		vSelect
	},
	watch: {
		forms: {
			handler(val) {
				if (val.type == 'percentage' && val.percentage != '' && val.nominal > 0) {
					this.forms.resume = 'Diskon ' + parseInt(this.forms.percentage) + '% maksimal Rp ' + formatCurrency(this.forms.nominal);
				} else if (val.type == 'fixed' && val.fixed > 0) {
					this.forms.resume = 'Diskon Rp ' + formatCurrency(this.forms.fixed);
				} else {
					this.forms.resume = null;
				}

				if (val.quota == 'unlimited') {
					this.forms.limit = null;
					this.errors.limit = false;
				}

				if (val.usage == 'user_limit') {
					this.forms.maximum = 1;
				}

				if (val.minimum == 'none') {
					this.forms.value = null;
				}

				if ((val.courier == 'all' || val.prefix.length > 0) && val.personality1 == 'service' && val.service1.length == 0) {
					authFetch('/master/courier/services' + (this.forms.prefix.length ? '?courier_id[]=' + this.forms.prefix.join('&courier_id[]=') : '')).then(res => {
						res.json().then((json) => {
							if (json.status) {
								this.listService1 = json.data;
							}
						});
					});
				}

				if (!val.shipper1.length && !val.service1.length && !val.member1.length && val.join_start1 == null && val.join_end1 == null && val.shipping1 == null && val.personality2) {
					this.forms.personality2 = '';
					this.resetPersonality2();
				}

				if ((val.courier == 'all' || val.prefix.length > 0) && val.personality2 == 'service' && val.service2.length == 0) {
					authFetch('/master/courier/services' + (this.forms.prefix.length ? '?courier_id[]=' + this.forms.prefix.join('&courier_id[]=') : '')).then(res => {
						res.json().then((json) => {
							if (json.status) {
								this.listService2 = json.data;
							}
						});
					});
				}
			},
			deep: true
		},
		shipper1: function (val) {
			this.viewShipper1.push(this.listShipper1.filter(function (el) {
				return el.id == val;
			})[0]);

			this.viewShipper1 = this.viewShipper1.filter(v => v && typeof v === 'object')
			.filter((value, index, self) =>
				index === self.findIndex((t) => (
					t.id === value.id && t.label === value.label
				))
			);

			this.forms.shipper1 = this.viewShipper1.map((item) => item.shipper_code);
		},
		shipper2: function (val) {
			this.viewShipper2.push(this.listShipper2.filter(function (el) {
				return el.id == val;
			})[0]);

			this.viewShipper2 = this.viewShipper2.filter(v => v && typeof v === 'object')
			.filter((value, index, self) =>
				index === self.findIndex((t) => (
					t.id === value.id && t.label === value.label
				))
			);

			this.forms.shipper2 = this.viewShipper2.map((item) => item.shipper_code);
		}
	},
	computed: {
		disableCode: function () {
			return this.forms.generate || this.loading || (!this.errors.code && this.errors.code_message) || this.$route.params.id;
		},
		shipper1: function () {
			return this.selectShipper1;
		},
		shipper2: function () {
			return this.selectShipper2;
		}
	},
	mounted() {
		const self = this;

		new Daterangepicker(
			this.$refs.period,
			{
				startDate: moment().startOf("month"),
				endDate: moment().endOf("month"),
				locale: {
					format: 'DD/MM/YYYY'
				},
			},
			function (d1, d2) {
				self.forms.period_start = d1.format("YYYY-MM-DD");
				self.forms.period_end = d2.format("YYYY-MM-DD");
			}
		);

		authFetch(`/order/province`).then((res) => {
			res.json().then((json) => {
				if (json.success) {
					this.listProvince = json.data;
				}
			});
		});

		authFetch(`/dashboard/admin/kurir`).then((res) => {
			res.json().then((json) => {
				if (json.success) {
					this.listCourier = json.data;
				}
			});
		});

		authFetch("/shipper/member_type/0").then(res => {
			res.json().then((json) => {
				if (json.status) {
					this.listMember1 = json.data;
					this.listMember2 = json.data;
				}
			});
		});

		this.customSwal = Swal.mixin({
			customClass: {
				content: 'p-0',
				title: 'h4 tex-dark',
				input: 'form-control',
				actions: 'd-flex justify-content-between flex-row-reverse',
				confirmButton: 'btn btn-primary col font-weight-bold',
				denyButton: 'btn btn-outline-primary col font-weight-bold',
				cancelButton: 'btn btn-primary w-75 font-weight-bold m-auto',
			},
			buttonsStyling: false
		});

		if (this.$route.params.id) {
			authFetch("/shipper/voucher/" + this.$route.params.id).then(res => {
				res.json().then((json) => {
					if (json.success) {
						this.active = json.data.active;

						const disorder = {
							shipper: json.shipper.length ? 'shipper' : null,
							service: json.courier.length ? 'service' : null,
							member: json.membership.length ? 'member' : null,
							join: json.data.join_start && json.data.join_end ? 'join' : null,
							shipping: json.data.shipping ? 'shipping' : null
						};

						const personality = Object.values(disorder).filter(val => val !== null);

						this.forms = {
							id: this.$route.params.id,
							save: null,
							generate: false,
							code: json.data.voucher_code,
							description: json.data.description,
							type: json.data.percent_voucher != null ? 'percentage' : 'fixed',
							percentage: json.data.percent_voucher != null ? Math.ceil(json.data.percent_voucher) : null,
							nominal: json.data.percent_voucher != null ? parseInt(json.data.voucher_value) : null,
							fixed: json.data.percent_voucher == null ? parseInt(json.data.voucher_value) :  null,
							resume: json.data.name,
							period_start: json.data.start_date,
							period_end: json.data.end_date,
							quota: json.data.qty != null ? 'limited' : 'unlimited',
							limit: json.data.qty,
							usage: ['daily_usage', 'fair_usage', 'user_limit'].includes(json.data.category) ? json.data.category : '',
							maximum: json.data.category != null ? json.data.qty_user : '',
							courier: json.data.courier_id == 0 ? 'all' : json.data.courier_id != null ? 'custom' : 'all',
							prefix: json.data.courier_id ? json.data.courier_id.split(',') : [],
							minimum: json.data.price_min == 0 ? 'none' : json.data.price_min ? 'value' : 'none',
							value: json.data.price_min ? json.data.price_min : json.data.price_min == 0 ? 0 : null,
							coverage: json.data.covered_origin != null || json.data.covered_destination != null ? 'custom' : 'all',
							origin: json.data.covered_origin ? json.data.covered_origin.split(',') : [],
							destination: json.data.covered_destination ? json.data.covered_destination.split(',') : [],
							publicity: json.data.private == 1 ? 'private' : 'public',
							personality1: personality[0] ?? '',
							shipper1: personality[0] == 'shipper' ? json.shipper.map((item) => item.shipper_code) : [],
							service1: personality[0] == 'service' ? json.courier.map((item) => item.id) : [],
							member1: personality[0] =='member' ? json.membership.map((item) => item.id) : [],
							join_start1: personality[0] == 'join' ? json.data.join_start : null,
							join_end1: personality[0] == 'join' ? json.data.join_end : null,
							shipping1: json.data.shipping,
							personality2: personality[1] ?? '',
							shipper2: personality[1] == 'shipper' ? json.shipper.map((item) => item.shipper_code) : [],
							service2: personality[1] == 'service' ? json.courier.map((item) => item.id) : [],
							member2: personality[1] =='member' ? json.membership.map((item) => item.id) : [],
							join_start2: personality[1] == 'join' ? json.data.join_start : null,
							join_end2: personality[1] == 'join' ? json.data.join_end : null,
							shipping2: json.data.shipping
						};

						this.viewShipper1 = personality[0] == 'shipper' ? json.shipper : [];
						this.viewShipper2 = personality[1] == 'shipper' ? json.shipper : [];

						this.listService1 = personality[0] == 'service' ? json.courier : [];
						this.listService2 = personality[1] == 'service' ? json.courier : [];

						if (json.data.active == 1) {
							this.customSwal = Swal.mixin({
								customClass: {
									content: 'p-0',
									title: 'h4 tex-dark',
									input: 'form-control',
									actions: 'd-flex justify-content-between flex-row-reverse',
									confirmButton: 'btn btn-danger col font-weight-bold',
									denyButton: 'btn btn-outline-danger col font-weight-bold',
									cancelButton: 'btn btn-primary w-75 font-weight-bold m-auto',
								},
								buttonsStyling: false
							});
						}

						if (personality[0] == 'join') {
							const self = this;

							new Daterangepicker(
								this.$refs.join_date1,
								{
									startDate: moment(json.data.join_start),
									endDate: moment(json.data.join_end),
									locale: {
										format: 'DD/MM/YYYY'
									},
								},
								function (d1, d2) {
									self.forms.join_start1 = d1.format("YYYY-MM-DD");
									self.forms.join_end1 = d2.format("YYYY-MM-DD");
								}
							);

							this.forms.join_start1 = json.data.join_start;
							this.forms.join_end1 = json.data.join_end;
						}

						if (personality[1] == 'join') {
							const self = this;

							new Daterangepicker(
								this.$refs.join_date2,
								{
									startDate: moment(json.data.join_start),
									endDate: moment(json.data.join_end),
									locale: {
										format: 'DD/MM/YYYY'
									},
								},
								function (d1, d2) {
									self.forms.join_start2 = d1.format("YYYY-MM-DD");
									self.forms.join_end2 = d2.format("YYYY-MM-DD");
								}
							);

							this.forms.join_start2 = json.data.join_start;
							this.forms.join_end2 = json.data.join_end;
						}
					}
				});
			});
		}
	}
};
</script>
<style>
.vs--single .vs__selected-options {
	overflow: hidden;
	white-space: nowrap;
}

.vs--single .vs__selected {
	width: 0;
}
</style>